import React, { useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid';

import Typography from '@mui/material/Typography';

import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';

import FormControl from '@mui/material/FormControl';

import Alert from '@mui/material/Alert';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';

import './NewPatient.css';

import {
	getPayers,
	postAddPatientData,
	savefilepost,
	getLocation,
	PostAttahcmentFile,
	postAddPatientInsuranceData,
	postPatNotes,
	getPatInsById,
	moveToMaximusExport,
} from '../../../services/api/apiManager';

import { states } from '../../../services/Settings';

import { DatePicker, DesktopDatePicker } from '@mui/x-date-pickers';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import {
	Autocomplete,
	Badge,
	Box,
	Divider,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Snackbar,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
} from '@mui/material';

import { useNavigate } from 'react-router';

import { useStateValue } from '../../../services/state/State';

import * as Yup from 'yup';

import WebLogo from '../../../../assets/logos/websitelogo.svg';

import CancelIcon from '@mui/icons-material/Cancel';

import AddIcon from '@mui/icons-material/Add';

import CallIcon from '@mui/icons-material/Call';

import MaskedInput from 'react-text-mask';
import { DataGrid } from '@mui/x-data-grid';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';

function NewPatient() {
	// for Save Button Disable
	const [addSave, setAddSave] = useState(false); // for Disabled Edit Save Button
	// Dispatch State Value
	const [{ providers }] = useStateValue();
	// Get Practice Id from Local Storage
	const practice_id = localStorage.getItem('practice_id');
	// Use Navigate Hook store in variable
	const darkNavigate = useNavigate();
	// Get Location from Location API State
	const [locationGet, setLocationGet] = React.useState([]);
	// Get Insurance from Insurance API State
	const [insListName, setInsListName] = useState([]);
	// Snackbar Open State if textfield posted
	const [openSnackbar, setOpenSnackbar] = useState(false);
	// Snackbar Open State if textfield empty
	const [openEmptySnackbar, setOpenEmptySnackbar] = useState(false);
	// Snackbar Open State if textfield empty
	const [openValidateSnackbar, setOpenValidateSnackbar] = useState(false);
	// Snackbar Open State if patient already exist
	const [openPatAlreadyExistSnackbar, setOpenPatAlreadyExistSnackbar] =
		useState(false);
	//  Error Validation State
	const [errors, setErrors] = useState({});
	// Pagination States here
	const [changePage, setChangePage] = useState({
		in_Page_Number: 0,
		in_Rows: 100,
	});
	const [paginationModel, setPaginationModel] = React.useState({
		page: 0,
		pageSize: 5,
	});
	// Loading State
	const [loading, setLoading] = useState(false);
	const fileInputRef = useRef(null);
	const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [insErrors, setInsErrors] = useState([]);
	const [insuranceForms, setInsuranceForms] = useState([]);
	const handleAddInsuranceForm = () => {
		setInsuranceForms((prev) => [
			...prev,
			{
				planName: '',
				insuranceName: '',
				policyNo: '',
				groupName: '',
			},
		]);
	};
	const handleCloseInsuranceForm = (indexNo) => {
		const removerForm = insuranceForms?.filter((items, index) => {
			return index != indexNo;
		});
		setInsuranceForms(removerForm);

		// Remove corresponding error at that index
		setInsErrors((prevErrors) => {
			const updatedErrors = [...prevErrors];
			updatedErrors.splice(indexNo, 1);
			return updatedErrors;
		});
	};

	// fucntion for getting patient insurance data By Id
	const [allInsuranceData, setAllInsuranceData] = useState([]);

	const getInsData = async (patientID) => {
		const resp = await getPatInsById(patientID);
		if (resp?.status === 200) {
			setPatientStates({
				fname: '',
				lname: '',
				dob: null,
				mrn: '',
				adm: null,
				room: '',
				bedNo: '',
				gender: '',
				provider: '',
				refphy: '',
				dischargeDate: null,
				location: '',
				contact: '',
				cnotes: '',
				pname: '',
				iname: '',
				policy: '',
				gname: '',
				address: '',
				cc: '',
				ccr: '',
				con: '',
				city: '',
				state: '',
				zip: '',
			});
			setSelectedFiles([]);
			setInsuranceForms([]);
			// setResPatInsurance(resp);
			// setIdOfInsData(resp?.data?.patient_insurances[0]?.id);
			// setInsIds(resp?.data?.patient_insurances?.slice(1)?.map((i) => i?.id));
			// setAllInsIds(resp?.data?.patient_insurances?.map((i) => i?.id));
			// setPatientStates((prevState) => ({
			// 	...prevState,
			// 	policy: resp?.data?.patient_insurances[0]?.PolicyNumber,
			// 	gname: resp?.data?.patient_insurances[0]?.GroupName,
			// 	pname: resp?.data?.patient_insurances[0]?.PlanName,
			// 	iname: resp?.data?.patient_insurances[0]?.payer_id,
			// }));
			const allInsuranceData = resp?.data?.patient_insurances || [];

			// All insurance forms
			const InsuranceData = allInsuranceData?.map((item, index) => ({
				id: index + 1,
				planName: item?.PlanName || '',
				insuranceName: item?.payer_id || '',
				policyNo: item?.PolicyNumber || '',
				groupName: item?.GroupName || '',
				action: 'put',
			}));
			setAllInsuranceData(InsuranceData);

			// Remaining insurance forms (from index 1 onwards)
			// const otherInsuranceData = allInsuranceData?.slice(1)?.map((item) => ({
			// 	planName: item?.PlanName || '',
			// 	insuranceName: item?.payer_id || '',
			// 	policyNo: item?.PolicyNumber || '',
			// 	groupName: item?.GroupName || '',
			// 	action: 'put',
			// }));
			// setInsuranceForms(otherInsuranceData);
		}
	};

	// const [dublicateFileSnack, setDublicateFileSnack] = React.useState(false);

	// const maxDate = new Date();
	// maxDate.setMonth(maxDate.getMonth() + 1);

	// All Patient Text Fields states here
	const [patientStates, setPatientStates] = useState({
		fname: '',
		lname: '',
		dob: null,
		mrn: '',
		adm: null,
		room: '',
		bedNo: '',
		gender: '',
		provider: '',
		refphy: '',
		dischargeDate: null,
		location: '',
		contact: '',
		cnotes: '',
		pname: '',
		iname: '',
		policy: '',
		gname: '',
		address: '',
		cc: '',
		ccr: '',
		con: '',
		city: '',
		state: '',
		zip: '',
	});

	const isFilled = (value) => {
		if (value == null) return false;
		const digitCount = (value.match(/\d/g) || [])?.length;
		return digitCount === 10;
	};

	const handleChangePatientStates = (e) => {
		// const { name, value } = e.target;
		// setPatientStates((prev) => {
		// 	return { ...prev, [name]: value };
		// });
		if (e?.target) {
			const { name, value } = e.target;
			setPatientStates((prev) => ({
				...prev,
				[name]: value,
			}));
		} else {
			setPatientStates((prev) => ({
				...prev,
				state: e,
			}));
		}
	};

	const handleDateOfBirthChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, dob: date };
		});
	};

	const handleAdmissionDateChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, adm: date };
		});
	};

	const handleDischargeDateChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, dischargeDate: date };
		});
	};

	const schema = Yup.object().shape({
		// Section of Alphabets only
		fname: Yup.string()
			.matches(/^[a-zA-Z]+$/, 'No spaces or special characters are allowed')
			.required('First Name is required'),
		lname: Yup.string()
			.matches(/^[a-zA-Z]+$/, 'No spaces or special characters are allowed')
			.required('Last Name is required'),
		// cnotes: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
		// 	return !value || /^[a-zA-Z\s]+$/.test(value);
		// }),
		pname: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		gname: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		// address: Yup.string().test(
		// 	'alphabets-numbers-only',
		// 	'Alphabets & numbers only',
		// 	(value) => {
		// 		return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
		// 	}
		// ),
		cc: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		ccr: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		city: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		state: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		// Section of Numbers only
		room: Yup.string().test(
			'alphabets-numbers-only',
			'Alphabets & numbers only',
			(value) => {
				return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
			}
		),
		bedNo: Yup.string().test(
			'alphabets-numbers-only',
			'Alphabets & numbers only',
			(value) => {
				return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
			}
		),
		policy: Yup.string().test(
			'alphanumeric-only',
			'Alphanumeric characters only',
			(value) => {
				return !value || /^[a-zA-Z0-9]+$/.test(value);
			}
		),
		zip: Yup.string().test('numbers-only', 'Numbers only', (value) => {
			return !value || /^\d+$/.test(value);
		}),
		mrn: Yup.string()
			.max(10, 'MRN must not exceed 10 characters')
			.test(
				'alphabets-numbers-only',
				'Only alphabets and numbers are allowed',
				(value) => !value || /^[a-zA-Z0-9]+$/.test(value)
			),
		// Section of Contact Number only
		contact: Yup.string().test('contact-format', 'Invalid', (value) => {
			return (
				!value ||
				/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)
			);
		}),
		con: Yup.string().test('contact-format', 'Invalid', (value) => {
			return (
				!value ||
				/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)
			);
		}),
		dob: Yup.date().required('Date of birth is required'),
		adm: Yup.date().required('Admission date is required'),
		dischargeDate: Yup.date().required('Discharge Date is required'),
	});
	const singleInsuranceSchema = Yup.object().shape({
		planName: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),

		groupName: Yup.string().test(
			'alphabets-only',
			'Alphabets only',
			(value) => {
				return !value || /^[a-zA-Z\s]+$/.test(value);
			}
		),

		policyNo: Yup.string().test(
			'alphanumeric-only',
			'Alphanumeric characters only',
			(value) => {
				return !value || /^[a-zA-Z0-9]+$/.test(value);
			}
		),
	});

	// Convert Date of Birth into string format
	const year = new Date(patientStates?.dob).getFullYear();
	const month = (new Date(patientStates?.dob).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day = new Date(patientStates?.dob)
		.getDate()
		.toString()
		.padStart(2, '0');
	const formattedDate = `${year}-${month}-${day}`;

	// Convert Admission Date into string format
	const year2 = new Date(patientStates?.adm).getFullYear();
	const month2 = (new Date(patientStates?.adm).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day2 = new Date(patientStates?.adm)
		.getDate()
		.toString()
		.padStart(2, '0');
	const admDate = `${year2}-${month2}-${day2}`;

	// Convert Discharge Date into string format
	const year3 = new Date(patientStates?.dischargeDate).getFullYear();
	const month3 = (new Date(patientStates?.dischargeDate).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day3 = new Date(patientStates?.dischargeDate)
		.getDate()
		.toString()
		.padStart(2, '0');
	const dischargeDate = `${year3}-${month3}-${day3}`;

	// Snackbar Open if textfield empty function

	const ShowEmptySnackbar = () => {
		setOpenEmptySnackbar(true);
	};
	const CancelEmptySnackbar = () => {
		setOpenEmptySnackbar(false);
		setOpenPatAlreadyExistSnackbar(false);
	};

	// Snackbar Open if textfield filled for posted Data

	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};
	const notes_PatientUpdateInformation = async (data) => {
		try {
			const response = await postPatNotes(data);
			console.log('Status check:', response);
		} catch (error) {
			console.error('Error:', error);
		}
	};
	// Post Patient Data & Patient Admission Data store on variable
	const PatientData = {
		practice_id: practice_id,
		Fname: patientStates?.fname,
		Lname: patientStates?.lname,
		...(patientStates?.dob && {
			DOB: formattedDate,
		}),
		// DOB: `${formattedDate}`,
		Gender: patientStates?.gender,
		Contact: patientStates?.contact,
		Address: patientStates?.address,
		City: patientStates?.city,
		State: patientStates?.state,
		Zip: patientStates?.zip,
		MRN: patientStates?.mrn,
		ClinicalNotes: patientStates?.cnotes,
		CareCoordinator: patientStates?.cc,
		CCContact: patientStates?.con,
		CCRelation: patientStates?.ccr,
		Deleted: false,
		Inactive: patientStates?.dischargeDate != null ? true : false,
		patient_admissions: [
			{
				practice_id: practice_id,
				...(patientStates?.refphy && {
					refphy_id: patientStates?.refphy,
				}),
				...(patientStates?.provider && {
					provider_id: patientStates?.provider,
				}),
				...(patientStates?.location && {
					location_id: patientStates?.location,
				}),
				...(patientStates?.adm && {
					Admission_date: admDate,
				}),
				// Admission_date: `${admDate}`,
				discharge_date:
					patientStates?.dischargeDate !== null ? `${dischargeDate}` : null,
				Bed_No: patientStates?.bedNo,
				Room_No: patientStates?.room,
				Deleted: false,
			},
		],
	};
	const OSW_id = localStorage.getItem('OSW_id');
	const moveToMaximusData = {
		OSW_id: OSW_id,
		visitids: '',
		practice_id: practice_id,
		patient_id: '',
	};
	const buttonSubmit = async (e) => {
		e.preventDefault();
		setAddSave(true);

		if (patientStates?.fname === '' || patientStates?.lname === '') {
			ShowEmptySnackbar();
			setTimeout(() => {
				setOpenSnackbar(false);
				setAddSave(false);
			}, 2500);
		} else if (errors.fname || errors.lname || errors.mrn) {
			setOpenValidateSnackbar(true);
			setTimeout(() => {
				setOpenValidateSnackbar(false);
				setAddSave(false);
			}, 1500);
		} else {
			if (patientStates?.iname !== '' && patientStates?.policy === '') {
				ShowEmptySnackbar();
				setTimeout(() => {
					setOpenSnackbar(false);
					setAddSave(false);
				}, 1500);
			} else {
				const resp = await postAddPatientData({
					...PatientData,
				});

				if (resp?.request?.status === 200) {
					const dupflag = 'true';
					setDuplicateModalOpen(true);
					setAddSave(false);
				} else if (resp?.status === 201 || resp?.status === 200) {
					if (resp?.status === 200 || resp?.status === 201) {
						if (OSW_id == '1') {
							moveToMaximusData.patient_id = resp?.data?.id;
							const resMaximus = await moveToMaximusExport(moveToMaximusData);
							console.log('res:', resMaximus);
						}
						const patientId = resp?.data?.id;
						getInsData(resp?.data?.id);

						// for Add single insurance if exists
						if (patientStates?.iname !== '') {
							const patientInsuranceData = {
								patient_id: patientId,
								...(patientStates?.policy && {
									PolicyNumber: patientStates?.policy,
								}),
								...(patientStates?.pname && { PlanName: patientStates?.pname }),
								...(patientStates?.gname && {
									GroupName: patientStates?.gname,
								}),
								...(patientStates?.iname && { payer_id: patientStates?.iname }),
								Type: 'P',
								Deleted: false,
							};

							await postAddPatientInsuranceData(patientInsuranceData);
						}

						// for Add multiple insurance forms
						if (insuranceForms?.length > 0) {
							let invalidFound = false;

							for (const item of insuranceForms) {
								const insuranceObj = {
									...(item?.planName && { PlanName: item?.planName }),
									...(item?.groupName && { GroupName: item?.groupName }),
									...(item?.policyNo && { PolicyNumber: item?.policyNo }),
									...(item?.insuranceName && { payer_id: item?.insuranceName }),
									patient_id: patientId,
									Type: 'P',
									Deleted: false,
								};

								// Send only if all fields are filled
								if (insuranceObj?.PolicyNumber && insuranceObj?.payer_id) {
									await postAddPatientInsuranceData(insuranceObj);
								} else {
									invalidFound = true;
								}
							}
						}
					}

					const notesData = {
						Patientid: resp?.data?.id,
						Visit_id: null,
						practice_id: practice_id,
						NoteCategory: 'patient',
						Platform: 'web',
						Notes: [{ NotesText: 'New patient created successfully.' }],
					};

					try {
						await notes_PatientUpdateInformation(notesData);
					} catch (error) {
						console.error('Error posting notes:', error);
					}

					for (const i of selectedFiles) {
						if (i) {
							const formData = new FormData();
							formData.append('file', i);
							formData.append('filepath', practice_id + '/' + resp?.data?.id);

							try {
								const savefile = await savefilepost(formData);
								const storeFileName = savefile?.data?.file_name;
								const storeFilePath = savefile?.data?.file_path;

								const AttachmentFilePost = {
									patient_id: resp?.data?.id,
									AttachmentName: storeFileName,
									Path: storeFilePath,
									Type: i?.type,
								};

								await PostAttahcmentFile(AttachmentFilePost);
							} catch (error) {
								console.error('Error uploading file:', error);
							}
						}
					}

					setOpenSnackbar(true);
					setTimeout(() => {
						setOpenSnackbar(false);
						darkNavigate('/patient_list');
						setAddSave(false);
					}, 1500);
					setLoading(false);
				}
			}
		}
	};
	// const handleDuplicateConfirm = async () => {
	// 	setDuplicateModalOpen(false);
	// 	setAddSave(true);

	// 	const resp = await postAddPatientData({ ...PatientData, dupflag: true });
	// 	if (resp?.status === 201 || resp?.status === 200) {
	// 		setOpenSnackbar(true);
	// 		setTimeout(() => {
	// 			setOpenSnackbar(false);
	// 			darkNavigate('/patient_list');
	// 			setAddSave(false);
	// 		}, 1500);
	// 	}
	// };
	const handleDuplicateConfirm = async () => {
		setDuplicateModalOpen(false);
		setAddSave(true);
		const resp = await postAddPatientData({ ...PatientData, dupflag: true });
		if (resp?.status === 201 || resp?.status === 200) {
			const notesData = {
				Patientid: resp?.data?.id,
				Visit_id: null,
				practice_id: practice_id,
				NoteCategory: 'patient',
				Platform: 'web',
				Notes: [{ NotesText: 'New patient created successfully.' }],
			};
			try {
				await notes_PatientUpdateInformation(notesData);
			} catch (error) {
				console.error('Error posting notes:', error);
			}
			setOpenSnackbar(true);
			setTimeout(() => {
				setOpenSnackbar(false);
				darkNavigate('/patient_list');
				setAddSave(false);
			}, 1500);
		} else {
			setAddSave(false);
		}
	};

	const showPayerName = async () => {
		const resp = await getPayers();
		setInsListName(resp?.data);
	};
	// Get Location from Location API function

	const getLocationData = async () => {
		const resp = await getLocation();
		setLocationGet(resp?.data);
	};

	const handleFileRemove = (fileToRemove) => {
		setSelectedFiles((prevFiles) =>
			prevFiles.filter((file) => file !== fileToRemove)
		);
		if (fileInputRef.current) {
			fileInputRef.current.value = [];
		}
	};
	useEffect(() => {
		showPayerName();
		getLocationData();
	}, []);

	// Data Grid Table Info...

	const InsuranceColumn = [
		{
			field: 'id',
			headerName: 'Sr.No',
			flex: 0.8,
			minWidth: 20,
		},
		{
			field: 'planName',
			headerName: 'Plan',
			flex: 1,
			minWidth: 70,
		},
		{
			field: 'insuranceName',
			headerName: 'Insurance',
			flex: 1,
			minWidth: 120,
			valueGetter: (params) => {
				const id = params?.row?.insuranceName;
				const match = insListName?.find((x) => x.id === id);
				return match ? match.Name : '';
			},
		},
		{
			field: 'groupName',
			headerName: 'Group',
			flex: 1,
			minWidth: 50,
		},
		{
			field: 'policyNo',
			headerName: 'Policy',
			flex: 0.5,
			minWidth: 80,
		},
		// {
		// 	field: 'actions',
		// 	headerName: 'Actions',
		// 	sortable: false,
		// 	filterable: false,
		// 	flex: 0.5,
		// 	minWidth: 90,
		// 	renderCell: (params) => {
		// 		// const currentId = allInsIds[params?.id - 1];
		// 		return (
		// 			<Box sx={{ display: 'flex', gap: 1 }}>
		// 				<Tooltip title="Edit" placement="left">
		// 					<IconButton
		// 						color="primary"
		// 						onClick={() => {
		// 							console.log('Edit', params?.row);
		// 						}}
		// 						size="small"
		// 						sx={{ color: '#0D406F' }}
		// 					>
		// 						<BorderColorIcon fontSize="small" />
		// 					</IconButton>
		// 				</Tooltip>
		// 				<Tooltip title="Delete" placement="top-end">
		// 					<IconButton
		// 						color="error"
		// 						onClick={() => {
		// 							console.log('Delete', params?.row);
		// 						}}
		// 						size="small"
		// 						sx={{ color: '#ED2828' }}
		// 					>
		// 						<DeleteIcon fontSize="small" />
		// 					</IconButton>
		// 				</Tooltip>
		// 			</Box>
		// 		);
		// 	},
		// },
	];

	return (
		<>
			<Box
				sx={{
					padding: '8px',
				}}
			>
				{loading ? (
					<div className="loading-container">
						<div className="logo-container">
							<img className="logo" src={WebLogo} alt="Website Logo" />
						</div>
					</div>
				) : (
					<>
						<Grid
							container
							xl={12}
							lg={12}
							md={12}
							sm={12}
							xs={12}
							sx={{ display: 'flex', gap: '5px' }}
						>
							{/* Patient Info */}
							<Grid
								item
								xl={3.8}
								lg={3.8}
								md={3.8}
								sm={12}
								xs={12}
								sx={{ border: '1px solid lightgray', borderRadius: '5px' }}
							>
								<Grid
									item
									xl={12}
									lg={12}
									md={12}
									sm={12}
									xs={12}
									sx={{
										borderBottom: '1px solid lightgray',
										padding: '10px',
										background: '#0D406F',
										borderTopRightRadius: '5px',
										borderTopLeftRadius: '5px',
									}}
								>
									<Typography
										sx={{
											fontSize: 18,
											fontWeight: '500',
											fontFamily: 'Poppins',
											color: 'white',
										}}
									>
										Patient Info
									</Typography>
								</Grid>
								<Grid
									container
									item
									columnSpacing={1}
									rowSpacing={1}
									sx={{ padding: '1px 5px' }}
								>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
										<TextField
											sx={{
												marginTop: '.5rem',
												marginBottom: '.5rem',
												'& .MuiInputLabel-asterisk': {
													color: 'red',
												},
											}}
											fullWidth
											size="small"
											name="fname"
											// onChange={(e) => {
											// 	handleChangePatientStates(e);
											// 	Yup.reach(schema, 'fname')
											// 		.validate(e.target.value)
											// 		.then(() => {
											// 			setErrors((prevErrors) => ({
											// 				...prevErrors,
											// 				fname: '',
											// 			}));
											// 		})
											// 		.catch((error) => {
											// 			setErrors((prevErrors) => ({
											// 				...prevErrors,
											// 				fname: error.message,
											// 			}));
											// 		});
											// }}
											value={patientStates?.fname}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'fname')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															fname: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															fname: error.message,
														}));
													});
											}}
											required
											label="First Name"
											variant="outlined"
											id="outlined-basic"
											autoComplete="off"
										/>
										{errors.fname && (
											<div
												style={{
													color: 'red',
													fontSize: '10px',
													marginTop: '-7px',
													marginBottom: '8px',
												}}
											>
												{errors.fname}
											</div>
										)}
										<LocalizationProvider dateAdapter={AdapterDayjs}>
											<DemoContainer
												components={['DatePicker', 'DesktopDatePicker']}
											>
												<DemoItem>
													<DatePicker
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														// disableFuture={true}
														label={
															<Box
																sx={{ display: 'flex', alignItems: 'center' }}
															>
																DOB
																{/* <Box
																	component="span"
																	sx={{ color: 'red', marginLeft: '2px' }}
																>
																	*
																</Box> */}
															</Box>
														}
														sx={{
															width: '100%',
														}}
														name="dob"
														value={patientStates?.dob}
														onChange={(e) => {
															handleDateOfBirthChange(e);
															Yup.reach(schema, 'dob')
																.validate(e)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		dob: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		dob: error.message,
																	}));
																});
														}}
													/>
												</DemoItem>
											</DemoContainer>
										</LocalizationProvider>
										{/* {errors.dob && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.dob}
											</div>
										)} */}
										<TextField
											sx={{
												marginTop: '1rem',
											}}
											fullWidth
											size="small"
											name="contact"
											value={patientStates?.contact}
											onChange={(e) => {
												handleChangePatientStates(e);
											}}
											InputProps={{
												endAdornment: (
													<InputAdornment position="start">
														<CallIcon sx={{ color: '#DDE6F1' }} />
													</InputAdornment>
												),
												inputComponent: MaskedInput,
												inputProps: {
													mask: [
														'(',
														/\d/,
														/\d/,
														/\d/,
														')',
														' ',
														/\d/,
														/\d/,
														/\d/,
														'-',
														/\d/,
														/\d/,
														/\d/,
														/\d/,
													],
												},
												sx: {
													borderRadius: '3px',
													height: '40px',
													'& .MuiOutlinedInput-input': {
														padding: '5px 0px 5px 6px',
													},
												},
											}}
											error={
												patientStates?.contact != '' &&
												!isFilled(patientStates?.contact)
											}
											helperText={
												patientStates?.contact != '' &&
												!isFilled(patientStates?.contact)
													? 'Please enter a valid phone number'
													: ''
											}
											label="Contact#"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.contact && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.contact}
											</div>
										)}
										<TextField
											sx={{
												marginTop: '1rem',
												marginBottom: '.5rem',
											}}
											fullWidth
											size="small"
											name="room"
											value={patientStates?.room}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'room')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															room: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															room: error.message,
														}));
													});
											}}
											label="Room#"
											variant="outlined"
											autoComplete="off"
										/>
										{/* {errors.room && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.room}
											</div>
										)} */}
										<LocalizationProvider dateAdapter={AdapterDayjs}>
											<DemoContainer
												components={['DatePicker', 'DesktopDatePicker']}
											>
												<DemoItem>
													<DesktopDatePicker
														// disableFuture
														size="small"
														slotProps={{
															textField: {
																size: 'small',
																InputLabelProps: {
																	sx: {
																		fontSize: {
																			lg: '16px',
																			md: '13px',
																			sm: '16px',
																			xs: '16px',
																		},
																	},
																},
															},
														}}
														sx={{
															width: '100%',
														}}
														name="adm"
														label={
															<Box
																sx={{ display: 'flex', alignItems: 'center' }}
															>
																Adm Date
																{/* <Box
																	component="span"
																	sx={{ color: 'red', marginLeft: '2px' }}
																>
																	*
																</Box> */}
															</Box>
														}
														value={patientStates?.adm}
														onChange={(e) => {
															handleAdmissionDateChange(e);
															Yup.reach(schema, 'adm')
																.validate(e)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		adm: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		adm: error.message,
																	}));
																});
														}}
													/>
												</DemoItem>
											</DemoContainer>
										</LocalizationProvider>
										{/* {errors.adm && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.adm}
											</div>
										)} */}
										<FormControl
											fullWidth
											size="small"
											sx={{
												marginTop: '1rem',
											}}
										>
											<InputLabel id="demo-simple-select-label">
												Provider
											</InputLabel>
											<Select
												value={patientStates?.provider}
												name="provider"
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															width: '130px',
															overflowY: 'auto',
															overflowX: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
												label="Provider"
												inputProps={{ 'aria-label': 'Without label' }}
											>
												{/* <MenuItem value={0}>None</MenuItem> */}
												{providers?.map((items, index) => {
													return (
														<MenuItem value={items?.id} key={index}>
															{items?.Lname + ',' + items?.Fname}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
										<TextField
											sx={{
												marginTop: '1rem',
											}}
											fullWidth
											size="small"
											name="address"
											autoComplete="off"
											value={patientStates?.address}
											onChange={(e) => {
												handleChangePatientStates(e);
												// Yup.reach(schema, 'address')
												// 	.validate(e.target.value)
												// 	.then(() => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			address: '',
												// 		}));
												// 	})
												// 	.catch((error) => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			address: error.message,
												// 		}));
												// 	});
											}}
											label="Address"
											variant="outlined"
										/>
										{errors.address && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.address}
											</div>
										)}
									</Grid>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
										<TextField
											sx={{
												marginTop: '.5rem',
												marginBottom: '1rem',
												'& .MuiInputLabel-asterisk': {
													color: 'red',
												},
											}}
											fullWidth
											size="small"
											name="lname"
											value={patientStates?.lname}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'lname')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															lname: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															lname: error.message,
														}));
													});
											}}
											required
											label="Last Name"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.lname && (
											<div
												style={{
													color: 'red',
													fontSize: '10px',
													marginTop: '-7px',
													marginBottom: '8px',
												}}
											>
												{errors.lname}
											</div>
										)}
										<FormControl fullWidth size="small">
											<InputLabel id="demo-simple-select-label">
												Gender
											</InputLabel>
											<Select
												value={patientStates?.gender}
												name="gender"
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												label="Gender"
												inputProps={{ 'aria-label': 'Without label' }}
											>
												<MenuItem value="M">Male</MenuItem>
												<MenuItem value="F">Female</MenuItem>
												<MenuItem value="O">Other</MenuItem>
											</Select>
										</FormControl>
										<TextField
											sx={{
												marginTop: '1rem',
											}}
											fullWidth
											size="small"
											name="mrn"
											autoComplete="off"
											value={patientStates?.mrn}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'mrn')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															mrn: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															mrn: error.message,
														}));
													});
											}}
											label="MRN"
											variant="outlined"
										/>
										{errors.mrn && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.mrn}
											</div>
										)}
										<TextField
											sx={{
												marginTop: '1rem',
												marginBottom: '.5rem',
											}}
											fullWidth
											size="small"
											name="bedNo"
											autoComplete="off"
											value={patientStates?.bedNo}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'bedNo')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															bedNo: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															bedNo: error.message,
														}));
													});
											}}
											label="Bed No"
											variant="outlined"
										/>
										{/* {errors.bedNo && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.bedNo}
											</div>
										)}{' '} */}
										<LocalizationProvider dateAdapter={AdapterDayjs}>
											<DemoContainer
												components={['DatePicker', 'DesktopDatePicker']}
											>
												<DemoItem>
													<DesktopDatePicker
														size="small"
														slotProps={{
															textField: {
																size: 'small',
																InputLabelProps: {
																	sx: {
																		fontSize: {
																			lg: '16px',
																			md: '13px',
																			sm: '16px',
																			xs: '16px',
																		},
																		textAlign: 'center',
																	},
																},
															},
														}}
														sx={{
															width: '100%',
														}}
														name="dischargeDate"
														label={
															<Box
																sx={{ display: 'flex', alignItems: 'center' }}
															>
																Discharge On
															</Box>
														}
														value={patientStates?.dischargeDate}
														disabled={!patientStates?.adm}
														// minDate={patientStates?.adm}
														onChange={(e) => {
															handleDischargeDateChange(e);
															Yup.reach(schema, 'dischargeDate')
																.validate(e)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		dischargeDate: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		dischargeDate: error.message,
																	}));
																});
														}}
													/>
												</DemoItem>
											</DemoContainer>
										</LocalizationProvider>
										{/* {errors.dischargeDate && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.dischargeDate}
											</div>
										)} */}
										<FormControl
											fullWidth
											size="small"
											sx={{
												marginTop: '1rem',
											}}
										>
											<InputLabel id="demo-simple-select-label">
												Ref Phy
											</InputLabel>
											<Select
												value={patientStates?.refphy}
												name="refphy"
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															width: '130px',
															overflowY: 'auto',
															overflowX: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
												label="Ref Phy"
												inputProps={{ 'aria-label': 'Without label' }}
											>
												{/* <MenuItem value={0}>None</MenuItem> */}
												{providers?.map((items, index) => {
													return (
														<MenuItem value={items?.id} key={index}>
															{items?.Lname + ',' + items?.Fname}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
										<FormControl
											fullWidth
											size="small"
											sx={{
												marginTop: '1rem',
											}}
										>
											<InputLabel id="demo-simple-select-label">
												Location
												{/* <span
													style={{
														fontSize: '16px',
														fontWeight: '400',
														fontFamily: 'Poppins',
														color: '#ED2828',
													}}
												>
													*
												</span> */}
											</InputLabel>
											<Select
												value={patientStates?.location}
												name="location"
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															width: '130px',
															overflowY: 'auto',
															overflowX: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
												label="Location"
												inputProps={{ 'aria-label': 'Without label' }}
											>
												{/* <MenuItem value={0}>None</MenuItem> */}
												{locationGet?.map((items, i) => {
													return (
														<MenuItem value={items?.id} key={i}>
															{items?.Name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Grid>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<Grid
											container
											columnSpacing={2}
											rowSpacing={2}
											sx={{ marginBottom: '5px' }}
										>
											<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
												{/* <TextField
													fullWidth
													size="small"
													name="state"
													onChange={(e) => {
														handleChangePatientStates(e);
														Yup.reach(schema, 'state')
															.validate(e.target.value)
															.then(() => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	state: '',
																}));
															})
															.catch((error) => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	state: error.message,
																}));
															});
													}}
													label="State"
													variant="outlined"
												/> */}
												<Autocomplete
													fullWidth
													size="small"
													name="state"
													options={states}
													getOptionLabel={(option) => option?.name || ''}
													value={
														states.find(
															(state) => state?.code === patientStates?.state
														) || null
													}
													onChange={(event, newValue) => {
														handleChangePatientStates(newValue?.code || '');
														Yup.reach(schema, 'state')
															.validate(newValue ? newValue?.code : '')
															.then(() => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	state: '',
																}));
															})
															.catch((error) => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	state: error.message,
																}));
															});
													}}
													ListboxProps={{
														style: {
															maxHeight: '160px', // Set the height here
														},
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															label="State"
															variant="outlined"
															error={errors.state}
															helperText={errors.state}
															sx={{
																// background: '#f2f2f2',
																'& .MuiOutlinedInput-root': {
																	'&.Mui-focused fieldset': {
																		borderColor: '#0E6368',
																	},
																},
															}}
														/>
													)}
												/>
												{errors.state && (
													<div style={{ color: 'red', fontSize: '10px' }}>
														{errors.state}
													</div>
												)}
											</Grid>
											<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
												<TextField
													fullWidth
													size="small"
													name="city"
													value={patientStates?.city}
													onChange={(e) => {
														handleChangePatientStates(e);
														Yup.reach(schema, 'city')
															.validate(e.target.value)
															.then(() => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	city: '',
																}));
															})
															.catch((error) => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	city: error.message,
																}));
															});
													}}
													label="City"
													variant="outlined"
													autoComplete="off"
												/>
												{errors.city && (
													<div style={{ color: 'red', fontSize: '10px' }}>
														{errors.city}
													</div>
												)}
											</Grid>
											<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
												<TextField
													fullWidth
													size="small"
													name="zip"
													value={patientStates?.zip}
													onChange={(e) => {
														handleChangePatientStates(e);
														Yup.reach(schema, 'zip')
															.validate(e.target.value)
															.then(() => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	zip: '',
																}));
															})
															.catch((error) => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	zip: error.message,
																}));
															});
													}}
													label="Zip"
													variant="outlined"
													autoComplete="off"
												/>
												{errors.zip && (
													<div style={{ color: 'red', fontSize: '10px' }}>
														{errors.zip}
													</div>
												)}
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
							{/* Care Team */}
							<Grid
								item
								xl={4}
								lg={4}
								md={4}
								sm={12}
								xs={12}
								sx={{ border: '1px solid lightgray', borderRadius: '5px' }}
							>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12} sx={{}}>
									<Typography
										sx={{
											fontSize: 18,
											fontWeight: '500',
											fontFamily: 'Poppins',
											color: 'white',
											borderBottom: '1px solid lightgray',
											padding: '10px',
											background: '#0D406F',
											borderTopRightRadius: '5px',
											borderTopLeftRadius: '5px',
										}}
									>
										Care Team
									</Typography>
								</Grid>
								<Grid
									container
									item
									xl={12}
									lg={12}
									md={12}
									sm={12}
									xs={12}
									sx={{ padding: '1px 10px' }}
								>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<TextField
											sx={{
												marginTop: '.5rem',
											}}
											fullWidth
											size="small"
											name="cc"
											value={patientStates?.cc}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'cc')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															cc: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															cc: error.message,
														}));
													});
											}}
											label="Care Coordinator"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.cc && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.cc}
											</div>
										)}
									</Grid>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<TextField
											sx={{
												marginTop: '1rem',
											}}
											fullWidth
											size="small"
											name="ccr"
											value={patientStates?.ccr}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'ccr')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															ccr: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															ccr: error.message,
														}));
													});
											}}
											label="Care Coordinator Relation"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.ccr && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.ccr}
											</div>
										)}
									</Grid>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<TextField
											sx={{
												marginTop: '.8rem',
											}}
											fullWidth
											size="small"
											name="con"
											value={patientStates?.con}
											onChange={(e) => {
												handleChangePatientStates(e);
											}}
											InputProps={{
												endAdornment: (
													<InputAdornment position="start">
														<CallIcon sx={{ color: '#DDE6F1' }} />
													</InputAdornment>
												),
												inputComponent: MaskedInput,
												inputProps: {
													mask: [
														'(',
														/\d/,
														/\d/,
														/\d/,
														')',
														' ',
														/\d/,
														/\d/,
														/\d/,
														'-',
														/\d/,
														/\d/,
														/\d/,
														/\d/,
													],
												},
												sx: {
													borderRadius: '3px',
													height: '40px',
													'& .MuiOutlinedInput-input': {
														padding: '5px 0px 5px 6px',
													},
												},
											}}
											error={
												patientStates?.con != '' &&
												!isFilled(patientStates?.con)
											}
											helperText={
												patientStates?.con != '' &&
												!isFilled(patientStates?.con)
													? 'Please enter a valid phone number'
													: ''
											}
											label="Contact#"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.con && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.con}
											</div>
										)}
									</Grid>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<TextField
											sx={{
												marginTop: '.8rem',
											}}
											fullWidth
											size="small"
											multiline
											rows={3}
											name="cnotes"
											value={patientStates?.cnotes}
											onChange={(e) => {
												handleChangePatientStates(e);
												// Yup.reach(schema, 'cnotes')
												// 	.validate(e.target.value)
												// 	.then(() => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			cnotes: '',
												// 		}));
												// 	})
												// 	.catch((error) => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			cnotes: error.message,
												// 		}));
												// 	});
											}}
											label="Clinical Notes"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.cnotes && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.cnotes}
											</div>
										)}
									</Grid>
								</Grid>

								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											padding: '10px',
										}}
									>
										<Typography
											sx={{
												fontSize: 18,
												fontWeight: '500',
												fontFamily: 'Poppins',
												color: '#BC1111',
											}}
										>
											Attachments
										</Typography>
										<Button
											variant="contained"
											component="label"
											size="small"
											sx={{
												background: '#2E68BA',
												color: 'white',
												fontSize: {
													xl: '12px',
													lg: '10px',
													md: '7px',
													sm: '12px',
													xs: '8px',
												},
											}}
										>
											<Box display={'flex'} alignItems={'center'} gap={1}>
												<AddIcon
													sx={{
														fontSize: {
															xl: '18px',
															lg: '18px',
															md: '18px',
															sm: '18px',
															xs: '16px',
														},
													}}
												/>
												Select Files
											</Box>
											<input
												ref={fileInputRef}
												type="file"
												multiple
												style={{ display: 'none' }}
												onChange={(e) => {
													// const files = Array.from(e.target.files);
													// setSelectedFiles((prev) => [...prev, ...files]);

													// const sotefiles = e.target.files;
													// const getFileNames = Array.from(sotefiles)?.map(
													// 	(i) => i?.name
													// );
													// console.log('---->>', getFileNames);
													// setSelectedFiles((prev) => {});

													const files = Array.from(e.target.files);
													const newFileNames = files?.map((file) => file?.name);
													setSelectedFiles((prevSelectedFiles) => {
														const existingFileNames = new Set(
															prevSelectedFiles?.map((file) => file?.name)
														);
														const duplicateInNewFiles = newFileNames.some(
															(name, index) =>
																newFileNames.indexOf(name) !== index
														);
														const duplicatesWithExisting = newFileNames.every(
															(name) => existingFileNames.has(name)
														);
														if (duplicateInNewFiles || duplicatesWithExisting) {
															// setDublicateFileSnack(true);
															// setTimeout(() => {
															// 	setDublicateFileSnack(false);
															// }, 1500);
															return prevSelectedFiles;
														} else {
															return [...prevSelectedFiles, ...files];
														}
													});
												}}
												accept=".pdf,.doc,.docx,.xls,.xlsx, .png, .jpg,.jpeg"
											/>
										</Button>
									</div>
									<Grid container>
										<Box sx={{ width: '100%' }}>
											{/* {dublicateFileSnack === true ? (
												<Box
													sx={{
														backgroundColor: '#0D406F',
														textAlign: 'center',
													}}
												>
													<span
														style={{
															color: 'white',
															fontWeight: '580',
															fontSize: '13px',
															fontFamily: 'Poppins',
														}}
													>
														This file already exist
													</span>
												</Box>
											) : (
												''
											)} */}
											{selectedFiles?.length > 0 && (
												<Box
													p={0}
													m={0}
													sx={{
														display: 'flex',
														flexDirection: 'column',
														padding: ' 5px 10px',
														margin: ' 5px 10px',
														height: {
															xl: '28vh',
															lg: '23vh',
															md: '23vh',
															sm: '23vh',
															xs: '23vh',
														},
														overflow: 'auto',
														border: '1px solid lightgray',
													}}
												>
													{selectedFiles?.map((file, index) => (
														<>
															<Grid container>
																<Grid
																	item
																	xl={11}
																	lg={11}
																	md={11}
																	sm={11}
																	xs={11}
																>
																	<Box
																		key={index}
																		display="flex"
																		alignItems="center"
																		justifyContent={'space-between'}
																		sx={{
																			borderRadius: '8px',
																			background: '#EDFFF4',
																			fontSize: '12px',
																			padding: '5px',
																			margin: '5px',
																			border: '1px solid lightgray',
																		}}
																	>
																		<Typography
																			variant="body2"
																			sx={{
																				mr: 1,
																				fontSize: {
																					xl: '15px',
																					lg: '10px',
																					md: '9px',
																					sm: '9px',
																					xs: '9px',
																				},
																			}}
																		>
																			{file?.name}
																		</Typography>
																	</Box>
																</Grid>
																<Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
																	<Box
																		sx={{
																			display: 'flex',
																		}}
																	>
																		<IconButton
																			size="small"
																			onClick={() => handleFileRemove(file)}
																			sx={{ border: '1px solid lightgray' }}
																		>
																			<CancelIcon
																				sx={{
																					fontSize: {
																						xl: '20px',
																						lg: '20px',
																						md: '18px',
																						sm: '20px',
																						xs: '20px',
																					},
																					color: 'red',
																				}}
																			/>
																		</IconButton>
																	</Box>
																</Grid>
															</Grid>
														</>
													))}
												</Box>
											)}
										</Box>
									</Grid>
								</Grid>
							</Grid>

							{/* Insurance Info */}
							<Grid
								item
								xl={4}
								lg={4}
								md={4}
								sm={12}
								xs={12}
								sx={{ border: '1px solid lightgray', borderRadius: '5px' }}
							>
								<Box
									sx={{
										borderBottom: '1px solid lightgray',
										padding: '10px',
										background: '#0D406F',
										borderTopRightRadius: '5px',
										borderTopLeftRadius: '5px',
									}}
								>
									<Typography
										sx={{
											fontSize: 18,
											fontWeight: '500',
											fontFamily: 'Poppins',
											color: 'white',
										}}
									>
										Insurance Info
									</Typography>
								</Box>
								{/* Data Grid Details */}
								{/* <Grid container spacing={2} padding={'5px 5px'}>
									<Grid item xs={12}>
										<Box
											sx={{
												height: '30vh',
											}}
										>
											<DataGrid
												rows={allInsuranceData}
												rowHeight={35}
												columnHeaderHeight={35}
												columns={InsuranceColumn}
												rowCount={allInsuranceData?.length}
												disableRowSelectionOnClick
												paginationModel={paginationModel}
												onPaginationModelChange={(e) => {
													setPaginationModel({
														page: e.page,
														pageSize: e.pageSize,
													});
													if (
														paginationModel.page != 0 &&
														paginationModel.pageSize === 10 &&
														paginationModel.page % 9 === 0
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													} else if (
														(paginationModel.page == 0 ||
															paginationModel.page !== 0) &&
														paginationModel.pageSize === 100
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													} else if (
														paginationModel.page != 0 &&
														paginationModel.pageSize === 25 &&
														paginationModel.page % 3 === 0
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													} else if (
														paginationModel.page != 0 &&
														paginationModel.pageSize === 50 &&
														paginationModel.page % 1 === 0
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													}
												}}
												pageSizeOptions={[5, 10, 25, 50, 100]}
												sx={{
													maxHeight: '40vh',
													'& .MuiDataGrid-columnHeader': {
														backgroundColor: '#2081B8',
														color: '#FFFFFF',
														fontFamily: 'Poppins',
														fontWeight: '300',
														fontSize: {
															xl: '15px',
															lg: '13px',
															md: '13px',
															sm: '13px',
															xs: '13px',
														},
														overflow: 'hidden',
														'.MuiSvgIcon-root': {
															color: 'white',
														},
													},
													'& .MuiDataGrid-footerContainer': {
														justifyContent: 'flex-start',
														backgroundColor: '#DCF0FF',
														height: '5px',
														fontSize: {
															xl: '15px',
															lg: '13px',
															md: '13px',
															sm: '13px',
															xs: '13px',
														},
													},

													'& .MuiInputBase-root': {
														border: '0.5px solid #383838',
														width: '60px',
														height: '30px',
														borderRadius: '10%',
														backgroundColor: 'white',
													},
													color: 'black',
													fontSize: {
														xs: '12px',
														sm: '12px',
														md: '12px',
														lg: '12px',
														xl: '14px',
													},
													'& .MuiDataGrid-virtualScroller': {
														overflowY: 'auto !important',
													},
													// '& .MuiTablePagination-displayedRows': {
													// 	display: 'none',
													// },
													'& .MuiTablePagination-selectLabel': {
														display: 'none',
													},
													// '& .MuiTablePagination-select': {
													// 	display: 'none',
													// },
													// '& .MuiTablePagination-selectIcon': {
													// 	display: 'none',
													// },
												}}
											/>{' '}
										</Box>
									</Grid>
								</Grid> */}

								<Grid
									container
									columnSpacing={1}
									rowSpacing={1}
									sx={{ padding: '1px 5px' }}
								>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
										<TextField
											sx={{
												marginTop: '.5rem',
											}}
											fullWidth
											size="small"
											name="pname"
											value={patientStates?.pname}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'pname')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															pname: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															pname: error.message,
														}));
													});
											}}
											label="Plan Name"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.pname && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.pname}
											</div>
										)}
										<TextField
											sx={{
												marginTop: '15px',
											}}
											fullWidth
											size="small"
											name="gname"
											value={patientStates?.gname}
											onChange={(e) => {
												handleChangePatientStates(e);
												Yup.reach(schema, 'gname')
													.validate(e.target.value)
													.then(() => {
														setErrors((prevErrors) => ({
															...prevErrors,
															gname: '',
														}));
													})
													.catch((error) => {
														setErrors((prevErrors) => ({
															...prevErrors,
															gname: error.message,
														}));
													});
											}}
											label="Group Name"
											variant="outlined"
											autoComplete="off"
										/>
										{errors.gname && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.gname}
											</div>
										)}
									</Grid>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
										<FormControl
											fullWidth
											size="small"
											sx={{
												marginTop: '.5rem',
											}}
										>
											<InputLabel
												id="demo-simple-select-label"
												sx={{
													fontSize: {
														lg: '16px',
														md: '13px',
														sm: '16px',
														xs: '16px',
													},
												}}
											>
												Insurance Name
											</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={patientStates?.iname}
												name="iname"
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															width: '130px',
															overflowY: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
												label="Insurance Name"
												inputProps={{ 'aria-label': 'Without label' }}
											>
												<MenuItem value={''}>None</MenuItem>
												{insListName?.map((items, index) => {
													return (
														<MenuItem value={items?.id} key={index}>
															{items?.Name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
										{patientStates?.iname && (
											<>
												<TextField
													sx={{
														marginTop: '15px',
														'& .MuiInputLabel-asterisk': {
															color: 'red',
														},
													}}
													fullWidth
													size="small"
													name="policy"
													value={patientStates?.policy}
													onChange={(e) => {
														handleChangePatientStates(e);
														Yup.reach(schema, 'policy')
															.validate(e.target.value)
															.then(() => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	policy: '',
																}));
															})
															.catch((error) => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	policy: error.message,
																}));
															});
													}}
													required
													label="Policy#"
													variant="outlined"
													autoComplete="off"
												/>
											</>
										)}
										{errors.policy && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.policy}
											</div>
										)}
									</Grid>
								</Grid>
								{/* Add Multiple insurance section */}
								<Box
									display="flex"
									justifyContent="flex-end"
									padding={'10px 0.5rem 0'}
								>
									{/* Add Icon */}
									<Button
										variant="contained"
										component="label"
										startIcon={<AddCircleIcon sx={{ fontSize: '18px' }} />}
										size="small"
										disabled={
											patientStates?.fname && patientStates?.lname
												? false
												: true
										}
										sx={{
											background: '#2E68BA',
											whiteSpace: 'nowrap',
											color: 'white',
											fontSize: {
												lg: '10px',
												md: '8px',
												sm: '9px',
												xs: '6px',
											},
										}}
										onClick={() => handleAddInsuranceForm()}
									>
										Add
									</Button>
								</Box>
								<Box
									sx={{
										maxHeight: {
											xs: '100px',
											lg: '200px',
										},
										overflowY: 'auto',
										overflowX: 'hidden',
										padding: '16px 0',
									}}
								>
									{insuranceForms?.map((form, index) => (
										<Badge
											badgeContent={
												<IconButton
													size="small"
													onClick={() => handleCloseInsuranceForm(index)}
													sx={{
														color: 'red',
														p: 0,
														mt: '8px',
														mr: '2.5rem',
													}}
												>
													<DoNotDisturbOnIcon fontSize="inherit" />
												</IconButton>
											}
											key={index}
										>
											<Grid
												container
												columnSpacing={1}
												rowSpacing={1}
												sx={{ padding: '10px 5px' }}
											>
												<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
													<TextField
														sx={{ marginTop: '.5rem' }}
														fullWidth
														size="small"
														name="planName"
														value={insuranceForms[index]?.planName}
														onChange={(e) => {
															const { name, value } = e.target;

															setInsuranceForms((prevForms) => {
																const updatedForms = [...prevForms];
																updatedForms[index] = {
																	...updatedForms[index],
																	[name]: value,
																};
																return updatedForms;
															});

															// Yup validation
															Yup.reach(singleInsuranceSchema, name)
																.validate(value)
																.then(() => {
																	setInsErrors((prevErrors) => {
																		const updatedErrors = [...prevErrors];
																		updatedErrors[index] = {
																			...updatedErrors[index],
																			[name]: '',
																		};
																		return updatedErrors;
																	});
																})
																.catch((error) => {
																	setInsErrors((prevErrors) => {
																		const updatedErrors = [...prevErrors];
																		updatedErrors[index] = {
																			...updatedErrors[index],
																			[name]: error.message,
																		};
																		return updatedErrors;
																	});
																});
														}}
														label="Plan Name"
														variant="outlined"
														autoComplete="off"
													/>

													{insErrors[index]?.planName && (
														<>
															<Typography
																variant="caption"
																style={{
																	color: 'red',
																	fontSize: '10.5px',
																	padding: 0,
																}}
															>
																{insErrors[index]?.planName}
															</Typography>
														</>
													)}
													<TextField
														sx={{
															marginTop: '15px',
														}}
														fullWidth
														size="small"
														name="groupName"
														value={insuranceForms[index]?.groupName || ''}
														onChange={(e) => {
															const { name, value } = e.target;

															setInsuranceForms((prevForms) => {
																const updatedForms = [...prevForms];
																updatedForms[index] = {
																	...updatedForms[index],
																	[name]: value,
																};
																return updatedForms;
															});

															// Yup validation
															Yup.reach(singleInsuranceSchema, name)
																.validate(value)
																.then(() => {
																	setInsErrors((prevErrors) => {
																		const updatedErrors = [...prevErrors];
																		updatedErrors[index] = {
																			...updatedErrors[index],
																			[name]: '',
																		};
																		return updatedErrors;
																	});
																})
																.catch((error) => {
																	setInsErrors((prevErrors) => {
																		const updatedErrors = [...prevErrors];
																		updatedErrors[index] = {
																			...updatedErrors[index],
																			[name]: error.message,
																		};
																		return updatedErrors;
																	});
																});
														}}
														label="Group Name"
														variant="outlined"
														autoComplete="off"
													/>
													{insErrors[index]?.groupName && (
														<div style={{ color: 'red', fontSize: '10px' }}>
															{insErrors[index]?.groupName}
														</div>
													)}
												</Grid>
												<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
													<FormControl
														fullWidth
														size="small"
														sx={{
															marginTop: '.5rem',
														}}
													>
														<InputLabel
															id="demo-simple-select-label"
															sx={{
																fontSize: {
																	lg: '16px',
																	md: '13px',
																	sm: '16px',
																	xs: '16px',
																},
															}}
														>
															Insurance Name
														</InputLabel>
														<Select
															labelId="demo-simple-select-label"
															id="demo-simple-select"
															name="insuranceName"
															value={insuranceForms[index]?.insuranceName || ''}
															onChange={(e) => {
																const { name, value } = e.target;

																setInsuranceForms((prevForms) => {
																	const updatedForms = [...prevForms];
																	updatedForms[index] = {
																		...updatedForms[index],
																		[name]: value,
																	};
																	return updatedForms;
																});
															}}
															MenuProps={{
																PaperProps: {
																	style: {
																		maxHeight: '200px',
																		width: '130px',
																		overflowY: 'auto',
																		scrollbarWidth: 'thin',
																		scrollbarColor: 'dark',
																		msOverflowStyle: 'none',
																		WebkitOverflowScrolling: 'touch',
																	},
																},
															}}
															label="Insurance Name"
															inputProps={{ 'aria-label': 'Without label' }}
														>
															<MenuItem value={''}>None</MenuItem>
															{insListName?.map((items, index) => {
																return (
																	<MenuItem value={items?.id} key={index}>
																		{items?.Name}
																	</MenuItem>
																);
															})}
														</Select>
													</FormControl>
													{form?.insuranceName && (
														<>
															<TextField
																sx={{
																	marginTop: '15px',
																	'& .MuiInputLabel-asterisk': {
																		color: 'red',
																	},
																}}
																fullWidth
																size="small"
																name="policyNo"
																value={insuranceForms[index]?.policyNo || ''}
																onChange={(e) => {
																	const { name, value } = e.target;

																	setInsuranceForms((prevForms) => {
																		const updatedForms = [...prevForms];
																		updatedForms[index] = {
																			...updatedForms[index],
																			[name]: value,
																		};
																		return updatedForms;
																	});
																	// Yup validation
																	Yup.reach(singleInsuranceSchema, name)
																		.validate(value)
																		.then(() => {
																			setInsErrors((prevErrors) => {
																				const updatedErrors = [...prevErrors];
																				updatedErrors[index] = {
																					...updatedErrors[index],
																					[name]: '',
																				};
																				return updatedErrors;
																			});
																		})
																		.catch((error) => {
																			setInsErrors((prevErrors) => {
																				const updatedErrors = [...prevErrors];
																				updatedErrors[index] = {
																					...updatedErrors[index],
																					[name]: error.message,
																				};
																				return updatedErrors;
																			});
																		});
																}}
																required
																label="Policy#"
																variant="outlined"
																autoComplete="off"
															/>
														</>
													)}
													{insErrors[index]?.policyNo && (
														<div style={{ color: 'red', fontSize: '10px' }}>
															{insErrors[index]?.policyNo}
														</div>
													)}
												</Grid>
											</Grid>
										</Badge>
									))}
								</Box>
							</Grid>
						</Grid>
						<Grid
							container
							xl={12}
							lg={12}
							md={12}
							sm={12}
							xs={12}
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
								alignItems: 'flex-end',
								gap: '10px',
								padding: '15px',
								height: {
									xl: '13vh',
									lg: '6vh',
									md: '5vh',
								},
							}}
						>
							<Button
								onClick={() => darkNavigate('/patient_list')}
								style={{
									backgroundColor: '#ED2828',
									fontSize: '12px',
								}}
								variant="contained"
								size="large"
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: addSave ? '#E0E0E0' : '#FD7702',
									fontSize: '12px',
								}}
								onClick={buttonSubmit}
								variant="contained"
								size="large"
								disabled={addSave ? true : false}
							>
								Save
							</Button>

							{/* Snackbar for Save button */}

							<Snackbar
								open={openSnackbar}
								onClose={handleCloseSnackbar}
								anchorOrigin={{
									vertical: 'center',
									horizontal: 'center',
								}}
							>
								<Alert
									onClose={handleCloseSnackbar}
									severity="success"
									variant="filled"
									sx={{
										width: '100%',
										height: '4rem',
										textAlign: 'center',
										fontSize: '1.1rem',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
									action={
										<React.Fragment>
											<span
												onClick={() => {
													darkNavigate('/patient_list');
												}}
												style={{
													cursor: 'pointer',
													m: 'auto 0',
													fontSize: '16px',
													color: 'rgb(231, 231, 231)',
												}}
											>
												Close
											</span>
										</React.Fragment>
									}
								>
									Patient Successfully Added !
								</Alert>
							</Snackbar>

							{/* Snackbar for Empty fields */}

							<Snackbar
								open={openEmptySnackbar}
								onClose={CancelEmptySnackbar}
								anchorOrigin={{
									vertical: 'center',
									horizontal: 'center',
								}}
							>
								<Alert
									onClose={CancelEmptySnackbar}
									severity="error"
									variant="filled"
									sx={{
										width: '100%',
										height: '4rem',
										textAlign: 'center',
										fontSize: '1.1rem',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
									action={
										<React.Fragment>
											<span
												onClick={CancelEmptySnackbar}
												style={{
													cursor: 'pointer',
													m: 'auto 0',
													fontSize: '16px',
													color: 'rgb(231, 231, 231)',
												}}
											>
												Close
											</span>
										</React.Fragment>
									}
								>
									Must Fill All Fields !
								</Alert>
							</Snackbar>
							{/* Snackbar for Validation fields */}

							<Snackbar
								open={openValidateSnackbar}
								onClose={CancelEmptySnackbar}
								anchorOrigin={{
									vertical: 'center',
									horizontal: 'center',
								}}
							>
								<Alert
									onClose={CancelEmptySnackbar}
									severity="error"
									variant="filled"
									sx={{
										width: '100%',
										height: '4rem',
										textAlign: 'center',
										fontSize: '1.1rem',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
									action={
										<React.Fragment>
											<span
												onClick={CancelEmptySnackbar}
												style={{
													cursor: 'pointer',
													m: 'auto 0',
													fontSize: '16px',
													color: 'rgb(231, 231, 231)',
												}}
											>
												Close
											</span>
										</React.Fragment>
									}
								>
									Must Validate All Fields !
								</Alert>
							</Snackbar>
							{/* Snackbar for Patient Already Exist */}

							<Snackbar
								open={openPatAlreadyExistSnackbar}
								onClose={CancelEmptySnackbar}
								anchorOrigin={{
									vertical: 'center',
									horizontal: 'center',
								}}
							>
								<Alert
									onClose={CancelEmptySnackbar}
									severity="error"
									variant="filled"
									sx={{
										width: '100%',
										height: '4rem',
										textAlign: 'center',
										fontSize: '1.1rem',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
									action={
										<React.Fragment>
											<span
												onClick={CancelEmptySnackbar}
												style={{
													cursor: 'pointer',
													m: 'auto 0',
													fontSize: '16px',
													color: 'rgb(231, 231, 231)',
												}}
											>
												Close
											</span>
										</React.Fragment>
									}
								>
									Patient Already Exist !
								</Alert>
							</Snackbar>
						</Grid>
					</>
				)}
			</Box>
			{/* <Modal
				open={duplicateModalOpen}
				onClose={() => setDuplicateModalOpen(false)}
				aria-labelledby="duplicate-modal-title"
				aria-describedby="duplicate-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: 400, // Slimmer table width
						bgcolor: 'background.paper',
						boxShadow: 24,
						p: 4,
						borderRadius: '8px',
					}}
				>
					<Typography
						id="duplicate-modal-title"
						variant="h6"
						component="h2"
						sx={{ mb: 2, textAlign: 'center', color: '#1976d2' }}
					>
						<h5>This Patient Name is Already Exists</h5>
					</Typography>
					<Typography
						id="duplicate-modal-description"
						sx={{ mb: 3, textAlign: 'center' }}
					>
						Do you want to add this patient again?
					</Typography>

					<Box
						sx={{
							border: '1px solid #ddd',
							borderRadius: '8px',
							overflow: 'hidden',
						}}
					>
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow
										sx={{
											backgroundColor: '#1976d2',
											'& > th': {
												color: 'white',
												fontWeight: 'bold',
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '14px',
											},
										}}
									>
										<TableCell>First Name</TableCell>
										<TableCell>Last Name</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow
										sx={{
											'&:hover': { backgroundColor: '#f5f5f5' },
											'& > td': {
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '14px',
											},
										}}
									>
										<TableCell>{PatientData?.Fname || 'N/A'}</TableCell>
										<TableCell>{PatientData?.Lname || 'N/A'}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Box>

					<Box
						sx={{ mt: 3, display: 'flex', justifyContent: 'end', gap: '5px' }}
					>
						<Button
							variant="outlined"
							color="error"
							onClick={() => setDuplicateModalOpen(false)}
						>
							No
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={handleDuplicateConfirm}
						>
							Yes
						</Button>
					</Box>
				</Box>
			</Modal> */}
			<Modal
				open={duplicateModalOpen}
				onClose={() => setDuplicateModalOpen(false)}
				aria-labelledby="duplicate-modal-title"
				aria-describedby="duplicate-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: 500,
						bgcolor: 'background.paper',
						boxShadow: 24,
						p: 2,
						borderRadius: '8px',
					}}
				>
					<Grid container>
						<Grid item xl={11} lg={11} md={11} sm={11} xs={11} align="left">
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '24px',
								}}
							>
								This Patient name is Already exist
								<span
									style={{
										fontFamily: 'Poppins',
										fontWeight: '600',
										fontSize: '16px',
										color: '#075AD7',
									}}
								></span>
							</Typography>
						</Grid>
						<Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
							<CancelIcon
								sx={{
									fontSize: '24px',
									color: 'red',
									marginLeft: '1rem',
									cursor: 'pointer',
								}}
								onClick={() => setDuplicateModalOpen(false)}
							/>
						</Grid>
					</Grid>

					<Typography
						id="duplicate-modal-description"
						sx={{ mt: 1, mb: 2, textAlign: 'center' }}
					>
						<h5>Do you want to add this patient again?</h5>
					</Typography>

					<Box
						sx={{
							border: '1px solid #ddd',
							borderRadius: '8px',
							overflow: 'hidden',
							mb: 2,
						}}
					>
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow
										sx={{
											backgroundColor: '#0D406F',
											'& > th': {
												color: 'white',
												fontWeight: '500',
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '12px',
											},
										}}
									>
										<TableCell>First Name</TableCell>
										<TableCell>Last Name</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow
										sx={{
											'& > td': {
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '11px',
											},
										}}
									>
										<TableCell>{PatientData?.Fname || 'N/A'}</TableCell>
										<TableCell>{PatientData?.Lname || 'N/A'}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Box>

					<Box sx={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
						<Button
							variant="outlined"
							color="error"
							onClick={() => setDuplicateModalOpen(false)}
							sx={{ backgroundColor: '#ED2828', color: 'white' }}
						>
							No
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={handleDuplicateConfirm}
							sx={{ backgroundColor: '#FD7702', color: 'white' }}
						>
							Yes
						</Button>
					</Box>
				</Box>
			</Modal>
		</>
	);
}

export default NewPatient;
